export default "__VITE_ASSET__C$0Ki3Oh__"